module.exports = __webpack_public_path__ + "static/media/PK.33ea7c00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PK.svg
// module id = 340
// module chunks = 0